<div class="asset-type-selector">
    <!-- Search Bar -->
    <div class="search-container">
      <div class="search-input-wrapper">
        <i class="fa-light fa-magnifying-glass search-icon"></i>
        <input
          type="text"
          [placeholder]="'Indicate a keyword' | translate"
          [value]="searchQuery()"
          (input)="onSearchChange($event)"
          class="search-input"
        />
        @if (searchQuery().trim()) {
          <button type="button" class="clear-btn" (click)="clearSearch()" tabindex="-1">
            <i class="fa-solid fa-times"></i>
          </button>
        }
      </div>
    </div>

    <!-- Search Results List -->
    @if (searchQuery().trim()) {
      @if (filteredAssetTypes().length > 0) {
        <cdk-virtual-scroll-viewport 
          class="asset-types-list" 
          itemSize="100" 
          minBufferPx="900" 
          maxBufferPx="1350">
          <div
            *cdkVirtualFor="let assetType of filteredAssetTypes(); trackBy: trackByAssetTypeId"
            class="asset-type-item"
            (click)="selectAssetType(assetType)">
            <div class="asset-type-name">{{ assetType.name }}</div>
            @if (assetType.super_category || assetType.category || assetType.sub_category) {
              <div class="asset-type-hierarchy">{{ getFormattedHierarchyPath(assetType) }}</div>
            }
          </div>
        </cdk-virtual-scroll-viewport>
      } @else {
        <div class="no-results">{{ "No results, please modify your search" | translate }}</div>
      }
    }

    <!-- Hierarchy Navigation Fields -->
    @if (!searchQuery().trim()) {
      <div class="hierarchy-container">
      <!-- Super Category -->
      <div class="hierarchy-field">
        <label class="hierarchy-label">{{ "Super category" | translate }}</label>
        <nb-select
          id="super_category"
          fullWidth
          [selected]="selectedSuperCategory()"
          (selectedChange)="selectSuperCategory($event)"
          class="hierarchy-select"
        >
          <nb-option [value]="null">-</nb-option>
          @for (superCategory of superCategories(); track superCategory.id) {
          <nb-option [value]="superCategory.id">
            {{ superCategory.name }}
          </nb-option>
          }
        </nb-select>
      </div>

      <!-- Category -->
      <div class="hierarchy-field" [class.disabled]="!selectedSuperCategory()">
        <label class="hierarchy-label">{{ "Category" | translate }}</label>
        <nb-select
          id="category"
          fullWidth
          [selected]="selectedCategory()"
          (selectedChange)="selectCategory($event)"
          [disabled]="!selectedSuperCategory()"
          class="hierarchy-select"
        >
          <nb-option [value]="null">-</nb-option>
          @for (category of filteredCategories(); track category.id) {
          <nb-option [value]="category.id">
            {{ category.name }}
          </nb-option>
          }
        </nb-select>
      </div>

      <!-- Sub Category -->
      <div class="hierarchy-field" [class.disabled]="!selectedCategory()">
        <label class="hierarchy-label">{{ "Sub category" | translate }}</label>
        <nb-select
          id="sub_category"
          fullWidth
          [selected]="selectedSubCategory()"
          (selectedChange)="selectSubCategory($event)"
          [disabled]="!selectedCategory()"
          class="hierarchy-select"
        >
          <nb-option [value]="null">-</nb-option>
          @for (subCategory of filteredSubCategories(); track subCategory.id) {
          <nb-option [value]="subCategory.id">
            {{ subCategory.name }}
          </nb-option>
          }
        </nb-select>
      </div>

      <!-- Equipment Type -->
      <div class="hierarchy-field" [class.disabled]="!selectedSubCategory()">
        <label class="hierarchy-label">{{ "Equipment type" | translate }}</label>
        <nb-select
          id="equipment_type"
          fullWidth
          [selected]="selectedAssetTypeId()"
          (selectedChange)="selectAssetTypeFromDropdown($event)"
          [disabled]="!selectedSubCategory()"
          class="hierarchy-select"
        >
          <nb-option [value]="null">-</nb-option>
          @for (assetType of filteredAssetTypes(); track assetType.id) {
          <nb-option [value]="assetType.id">
            {{ assetType.name }}
          </nb-option>
          }
        </nb-select>
      </div>
    </div>
    }
</div>


